import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero-Section";
import ContactSection from "./components/Contact-Section";
import Footer from "./components/Footer-Section";
import FounderTeam from "./components/FounderTeam";


import Home1 from "./components/Home1";
import HomeInfo from "./components/HomeInfo";
import KPI1 from "./components/KPI1";
import Home2 from "./components/Home2";
import Home3 from "./components/Home3";
import InfoSection1 from "./components/InfoSection1";
import InfoSection2 from "./components/InfoSection2";
import InfoSection3 from "./components/InfoSection3";
import InfoSectionTimeline from "./components/InfoSectionTimeline";
import InfoSectionProjekte from "./components/InfoSectionProjekte";
import SpacerCTA from "./components/SpacerCTA";
import LegalModal from "./components/LegalModal";

import "./variables.css";
import "./App.css";
import "./Hero.css";
import "./Contact.css";
import "./Footer.css";
import "./FounderTeam.css";

import "./Home1.css";
import "./HomeInfo.css";
import "./KPI1.css";
import "./Home2.css";
import "./Home3.css";
import "./InfoSection1.css";
import "./InfoSection2.css";
import "./InfoSection3.css";
import "./InfoSectionTimeline.css";
import "./InfoSectionProjekte.css";
import "./SpacerCTA.css";
import "./LegalModal.css";

import "./fonts.css";

// Verhindert nervige ResizeObserver-Warnungen im Browser
const originalError = console.error;
console.error = function (...args) {
  if (
    args.length > 0 &&
    typeof args[0] === "string" &&
    args[0].includes("ResizeObserver loop")
  ) {
    return;
  }
  originalError(...args);
};


function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Hero />
              <Home1 />
              <HomeInfo />
              <KPI1 />
              <Home3 />
              <Home2 />
              <InfoSectionTimeline />
              <InfoSection1 />
              <InfoSectionProjekte />
              <SpacerCTA />
              <InfoSection2 />
              <InfoSection3 />
              <FounderTeam /> 
              <ContactSection />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
